import { erpAxios } from '..';

const editAnalysisSuduznik = async (data) => {
  const res = await erpAxios.post(`/analiza/editAnalizaSuduznik`, data);
  return res;
};

export default editAnalysisSuduznik;
